import { Context } from 'react'
import { ReactSVG } from 'react-svg'
import ListSort from '../../../components/ui/ListSort'
import { t } from '../../../utils'
import styles from './_storeListHeader.module.scss'

const StoreListHeader: React.FC<{
  svgPath: string
  title: string
  searchContext?: Context<any>
  filtersNames?: string[]
}> = ({ svgPath, title, searchContext, filtersNames }) => {
  return (
    <>
      <div className={styles.storeSongsTitle}>
        <ReactSVG src={svgPath} />
        <h1> {t(title)}</h1>
      </div>
      {searchContext && (
        <div className={styles.storeSort}>
          <ReactSVG src="./../images/sort.svg" />
          <span className={styles.sortLabel}>{t('Sort by:')}</span>
          <ListSort
            SearchContext={searchContext}
            filtersNames={filtersNames}
            isStore={true}
          />
        </div>
      )}
    </>
  )
}

export default StoreListHeader
